import * as React from 'react';

import AppMessage from 'bundles/teach-course/components/AppMessage';

import _t from 'i18n!nls/teach-course';

type Props = {
  className?: string;
};

class AppLoadingMessage extends React.Component<Props> {
  render() {
    return <AppMessage heading={_t('Loading...')} className={this.props.className} />;
  }
}

export default AppLoadingMessage;
